import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import tz from 'dayjs/plugin/timezone';
import { environment } from '../../../environments/environment';
import { EncryptionService } from '../../../services/encryption.service';

dayjs.extend(utc);
dayjs.extend(tz);

@Injectable()
export class SetInterceptor implements HttpInterceptor {
  constructor(
    private _encryptionSerivce: EncryptionService,
  ) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const clonedReq = this.handleRequest(req);
    return next.handle(clonedReq);
  }
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleRequest(req: HttpRequest<unknown>) {
    const storageKey = localStorage.getItem(environment.storageKey);
    const token: string | null = storageKey ? storageKey : null;

    const currentDateUTC = new Date().toISOString();
    const headers = {
      'Content-Type': 'application/json',
      authorization: token ? `Bearer ${token}` : '',
      timeZone: dayjs.tz.guess(),
      date: currentDateUTC
    };

    let authReq = req.clone({
      headers: new HttpHeaders({
        hash: this._encryptionSerivce.encryptHeaders(headers),
        devicetype: 'web'
      })
    });

    if (
      req.method.toLowerCase() === 'post' ||
      req.method.toLowerCase() === 'put'
    ) {
      if (!req.url.includes('upload')) {
        // eslint-disable-next-line prefer-const
        authReq = authReq.clone({
          body: {
            hash: this._encryptionSerivce.encryptionPayload(
              JSON.stringify(authReq.body)
            )
          }
        });
      }
    }
    return authReq;
  }
}
